import React, { Component } from 'react';
import { TextField } from '@mui/material';
import i18n from '../../i18n';
import { formatPhoneNumberForUi } from '../../utils/formatNumber';

/**
 * A phone number, labelled like every other field: it used to say "Phone Number"
 * in English whatever the column, with an icon that kept the label raised, and
 * took no part in validation.
 */
class DialogPhoneField extends Component {
    constructor(props) {
        super(props);
        this.state = {
            value: formatPhoneNumberForUi(props.value)
        };
    }
    handlePhoneNumberChange = (event) => {
        this.props.onChange(this.props.field.id, event.target.value);
        this.setState({ value: event.target.value });
    };
    render() {
        const { field, error, onBlur, autoFocus, disabled } = this.props;
        return (
            <TextField
                id={field.id}
                label={i18n.t(`columns.${field.label}`)}
                type="tel"
                autoComplete="tel"
                fullWidth
                autoFocus={autoFocus}
                required={Boolean(field.required)}
                disabled={Boolean(disabled || field.onlyRead)}
                error={Boolean(error)}
                helperText={error}
                onBlur={onBlur}
                value={this.state.value || ''}
                onChange={this.handlePhoneNumberChange}
            />
        );
    }
}

export default DialogPhoneField;
